import request from "@/utils/request";

export default function agentChangeCard(params) {
    return request({
        url: `/user/card/agentChangeCard`,
        method: 'post',
        params: params
    })
}
